<template>
  <div class="app">
    <nav-bar />
    <section class="site-content">
      <div class="main-content container">
        <router-view />
      </div>
    </section>
    <nav class="navbar is-fixed-bottom">
      <footer class="footer">
        <div class="content has-text-centered">
          <p>
            <translate>Developed By</translate>
            &nbsp;
            <strong>
              <a
                href="https://deductivelabs.com"
                target="_blank">Deductive Labs</a>
            </strong>
          </p>
        </div>
      </footer>
    </nav>
  </div>
</template>

<script>

import axios from "axios";
import NavBar from '../components/NavBar'

export default {
  name: 'App',
  components: {
    NavBar
  },
  created() {
    var self = this
    setInterval(function () {
      // update data every 1000 ms
      self.renew_token()
    }, 60*1000)
  },
  methods: {
    renew_token: function(){
      var self = this
      let user = JSON.parse(localStorage.getItem('user'));
      if (user === null){
        return
      }
      const requestOptions = {
        method: 'POST',
        url: '/api/token/refresh/',
        headers: { 'Content-Type': 'application/json' },
        data: {
          refresh: user.refresh,
        }
      };
      axios(requestOptions)
        .then(function(response){
          user.access = response.data.access
          localStorage.setItem('user', JSON.stringify(user));
        })
        .catch(function(error){
          console.debug(error.response)
          if (error.response.statusText == "Unauthorized"){
            console.debug('Log out')
            self.$store.dispatch('authentication/logout');
          }
          return
        })
    },
  },
}
</script>

<style>
  @import "https://cdn.materialdesignicons.com/2.5.94/css/materialdesignicons.min.css";
  @import "/css/flag-icon.min.css";
  html, body {
  }
  body {
    background-image: url(/img/trollingtraff-bakgrund.jpg) ;
    background-position: center center;
    background-repeat:  no-repeat;
    background-attachment: fixed;
    background-size:  cover;
    background-color: #999;
    font-size: 14px;
  }
  .app {
    min-height: 100vh;
    flex-direction: column;
  }
  .main-content {
    display: flex;
    height: 100vh;
    padding: 30px;
    margin-bottom: 50px;
    background: white;
  }
  .container {
    min-height: 100%;
    height: 100%;
    overflow: auto;
  }
  .site-content {
    flex: 1;
  }
  .footer {
    padding: 1rem;
    width: 100%;
  }
</style>
